import { Injectable } from "@angular/core";
import { MetaTagsService } from "./meta-tags.service";

export enum PageTitles {
  Default = "Knowledge Exchange",
  About = "About",
  Topics = "Topics",
  Directory = "Contributors",
  KnowledgeExplorer = "Knowledge Explorer",
  CommunityProfiles = "Community Profile Tool",
  Video = "Video",
  Question = "Question",
  Story = "Story",
  Podcast = "Podcast",
}

@Injectable({ providedIn: "root" })
export class TitleService {
  constructor(private metaTags: MetaTagsService) {}
  
  PageTitles = PageTitles;
  setDefaultTitle = () => this.metaTags.setDefaultTitle();
  setPageTitle = (title) => this.metaTags.updateTitle(title);
}
